import axios from 'axios';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

const getAvailableLocales = async (merchantId) => {
  const { data } = await axios.get(
    `/api/merchants/${merchantId}/available-locales`,
  );
  return data.data;
};

const passMerchantId =
  (queryFn) =>
  ({ queryKey: [_, merchantId] }) =>
    queryFn(merchantId);

const composeQueryKey = (merchantId) => [
  'merchant-available-locales',
  merchantId,
];

export const useQueryAvailableLocales = (options) => {
  const { merchantId } = useParams();
  return useQuery(
    composeQueryKey(merchantId),
    passMerchantId(getAvailableLocales),
    {
      placeholderData: [],
      ...options,
    },
  );
};
